/**
 * Maps tenant alias to the appropriate logo path based on theme mode
 */
export const getTenantLogo = (tenantAlias: string | undefined, isDarkMode: boolean): string => {
  switch (tenantAlias) {
    case 'nvs':
    case 'nvs-test':
      return isDarkMode ? '/assets/nvs-logo-dark.png' : '/assets/nvs-logo.png';
    default:
      return '/assets/podium-logo.svg';
  }
};

/**
 * Maps tenant alias to the appropriate small logo path
 */
export const getTenantSmallLogo = (tenantAlias: string | undefined): string => {
  switch (tenantAlias) {
    case 'nvs':
    case 'nvs-test':
      return '/assets/nvs-logo-sm.png';
    default:
      // TODO: We need to get a proper small logo for Podium from UI/UX team
      return '/assets/podium-logo.svg';
  }
};
